import request from '@/plugin/axios'

export function searchUsers(data) {
    return request({
        url: '/api/admin/user',
        method: 'get',
        params: data
    })
}
export function addUser(data) {
    return request({
        url: '/api/admin/user',
        method: 'post',
        data: data
    })
}
export function updateUser(data) {
    return request({
        url: '/api/admin/user/' + data.id,
        method: 'put',
        data: data
    })
}
export function resetPassWord(data) {
    return request({
        url: '/api/admin/passRe',
        method: 'post',
        data: data
    })
}
export function queryUserInfoById(data) {
    return request({
        url: '/api/admin/me',
        method: 'post',
        data: data
    })
}
export function bindUserCenterId(data) {
    return request({
        url: '/api/admin/bindUserCenterId',
        method: 'post',
        data: data
    })
}
